import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import AiClerkAvatar from './AiClerkAvatar'
import Lucide from '../home/guide/Lucide'
import './PhotoReportEntry.scss'

/**
 * AI 填表员 · 拼图汇报入口横条(矮版)
 *
 * 场景:照片拼图 / 拼图汇报页面 header 下方。
 * 痛点(还在一张张肉眼找图写文档吗?)→ AI 自动把照片和数据填进 Excel / Word 文档。
 * 右上角可关闭,关闭后写入 localStorage,下次不再展示。
 */

const STORAGE_KEY = 'jigsaw-photo-report-entry-dismissed'

// 按文档格式分色:Excel 表格(绿) / Word 文档(蓝) / 汇报文件(紫)
type Cat = 'excel' | 'word' | 'report'

const ROW1: Array<[string, Cat]> = [
  ['施工日报', 'word'],
  ['巡检记录表', 'excel'],
  ['每日工作汇报', 'word'],
  ['现场签到表', 'excel']
]

const ROW2: Array<[string, Cat]> = [
  ['项目周报', 'report'],
  ['监理日志', 'word'],
  ['隐患整改单', 'excel']
]

function Tag({ label, cat }: { label: string; cat: Cat }) {
  return (
    <span className={`photo-report-entry__tag photo-report-entry__tag--${cat}`}>
      <i className="photo-report-entry__dot" />
      {label}
    </span>
  )
}

export default function PhotoReportEntry({
  onUpload
}: {
  onUpload?: () => void
}) {
  const navigate = useNavigate()
  const [visible, setVisible] = useState(
    () => localStorage.getItem(STORAGE_KEY) !== 'true'
  )

  const handleClose = () => {
    localStorage.setItem(STORAGE_KEY, 'true')
    setVisible(false)
  }

  if (!visible) {
    return null
  }

  return (
    <div className="photo-report-entry">
      <button
        type="button"
        className="photo-report-entry__close"
        onClick={handleClose}
        aria-label="关闭"
      >
        <Lucide name="x" size={14} />
      </button>

      <div className="photo-report-entry__left">
        <AiClerkAvatar size={30} />
        <div className="photo-report-entry__text">
          <div className="photo-report-entry__title">
            还在一张张肉眼找图写文档吗？
          </div>
          <div className="photo-report-entry__sub">
            AI 自动将照片和数据填入文档
          </div>
        </div>
      </div>

      <span className="photo-report-entry__divider" />

      <div className="photo-report-entry__tags">
        <div className="photo-report-entry__tag-row">
          {ROW1.map(([label, cat]) => (
            <Tag key={label} label={label} cat={cat} />
          ))}
        </div>
        <div className="photo-report-entry__tag-row">
          {ROW2.map(([label, cat]) => (
            <Tag key={label} label={label} cat={cat} />
          ))}
          <span className="photo-report-entry__tag photo-report-entry__tag--more">
            + 更多文档
          </span>
        </div>
      </div>

      <div className="photo-report-entry__right">
        <button
          type="button"
          className="photo-report-entry__cta"
          onClick={() => {
            if (onUpload) {
              onUpload()
            } else {
              navigate('/ai/clerk?from=jigsaw')
            }
          }}
        >
          <span>开始填表</span>
        </button>
      </div>
    </div>
  )
}
